// src/components/SessionEndedNotice.jsx
// Карточка "Сессия завершена" на главной — когда пользователь оказался здесь уже без сессии
// (например, F5 во вкладке, где сессию заменил вход с другого устройства).
// Во время работы вместо неё показывается SessionExpiredModal поверх страницы.
// Висит, пока пользователь не закроет её или не нажмёт «Войти».

import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from './ui';

// reason — ключ перевода App.*: 'session_replaced' | 'session_expired'
export const SessionEndedNotice = ({ reason, onSignIn, onClose }) => {
  const { t } = useTranslation();

  return (
    // Ниже шапки лендинга и поверх неё: шапка тоже fixed z-50
    <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[60] w-full max-w-md px-4" role="alert">
      <div className="animate-notice-in bg-white rounded-xs shadow-2xl p-5 flex gap-4">
        <div className="w-1 rounded-full bg-brand-accent flex-shrink-0" />
        <div className="flex-1 min-w-0 space-y-3">
          <div className="space-y-1">
            <p className="font-black text-gray-900">{t('App.session_expired_title')}</p>
            <p className="text-sm text-gray-600 leading-relaxed">{t(`App.${reason}`)}</p>
          </div>
          <Button size="sm" onClick={onSignIn}>{t('LandingPage.nav_login')}</Button>
        </div>
        <Button variant="icon" onClick={onClose} className="self-start text-gray-400 hover:text-gray-900">
          <X size={16} />
        </Button>
      </div>
    </div>
  );
};
